import { tokenService } from 'src/services/tokenService'

export const setupAuthInterceptor = (client) => {
  client.interceptors.request.use(
    (config) => {
      const token = tokenService.getToken(config.useAuthToken)

      if (token) {
        config.headers = config.headers || {}
        config.headers.Authorization = `Bearer ${token}`
      }

      if (config.data instanceof FormData) {
        config.headers['Content-Type'] = 'multipart/form-data'
      }

      return config
    },
    (error) => Promise.reject(error),
  )
}
